module.exports = __webpack_public_path__ + "img/20190222_183706_001.6c5401e8.jpg";